import './style.css';
import NodeComponent from "../node";
import {SettingNodeIcon} from "./icons";

export function AuthNode({ id, data }) {
    return (
        <NodeComponent title="Auth Action" id={id} data={data} nodeTypeIcon={<SettingNodeIcon/>}>
            <div></div>
        </NodeComponent>
    );
}

